import Store from '@/store'

import OAuth from '@/models/OAuth'
import { setOAuthToken } from '@/models/factory/Siprec'

let Auth = {
  /**
   * Returns if user is authorized to use application.
   * Users that have to change their password to continue or
   * perform any other actions to use application are not authorized.
   */
  isAuthorized () {
    return this.isLogged() &&
      !Store.auth.user.changePasswordAfterLogin &&
      !Auth.requiresKey()
  },

  /**
   * Returns if users needs to set master key to be authorized.
   */
  requiresKey () {
    return Store.auth.user &&
      Store.auth.user.role === 'COMPANY_ADMIN' &&
      Store.auth.user.company &&
      Store.auth.user.company.requireEncryption &&
      (!Store.auth.user.company.configuration ||
      Store.auth.user.company.configuration.encrypt !== 'KEY' ||
      !Store.auth.user.company.configuration.encryptionKeyExists)
  },

  /**
   * Returns if user is logged in.
   */
  isLogged () {
    return !!Store.auth.user
  },

  /**
   * Returns if user is authorized as any of specified roles.
   * @param {string|string[]} role one or more roles
   * @param {boolean} ignoreDelegations don't use delegations
   * @return {boolean} if user is authorized as any of specified roles
   */
  hasRole (role, ignoreDelegations) {
    // User that is required to change password has access nowhere
    if (Store.auth.user.changePasswordAfterLogin) {
      return false
    }

    // Multiple roles specified
    if (Array.isArray(role)) {
      return !!role.find(role => this.hasRole(role, ignoreDelegations))
    }

    // If we have delegation active, automatically approve company admin
    if (!ignoreDelegations && role === 'COMPANY_ADMIN' && Store.auth.user.companyDelegation) {
      return true
    }

    return Store.auth.user.role === role
  },

  isAuditor () {
    return this.hasRole('COMPANY_USER') && Store.auth.user.companyAuditor
  },

  /**
   * Returns user model.
   * This loads the model when required, this prevents issues with localization not being loaded.
   * @return {UserModel} user model
   */
  user () {
    return require('@/models/User').default
  },

  install (Vue) {
    Vue.prototype.$auth = Auth
  },

  login (username, password) {
    return OAuth.getToken(username, password)
      .then(token => {
        setOAuthToken(token)
        Store.auth.token = token
        return this.user().getSelf(username)
      })
  },

  useToken (token, username) {
    setOAuthToken(token)
    Store.auth.token = token
    return this.user().getSelf(username)
  },

  getUser () {
    return Store.auth.user
  },

  logout () {
    return this.user()
      .logout()
      .catch(() => this.clear())
      .then(() => this.clear())
  },

  clear () {
    Store.auth.token = null
    Store.auth.user = null
    Store.auth.username = null

    setOAuthToken(null)
  }
}

export default Auth



// WEBPACK FOOTER //
// ./src/utils/Auth.js